import {
  DynamoDBClient,
  GetItemCommand,
  ScanCommand,
  ScanCommandInput,
  ScanCommandOutput,
} from "@aws-sdk/client-dynamodb";
import { unmarshall } from "@aws-sdk/util-dynamodb";
import axios from "axios";
import { Credentials } from "@aws-sdk/types";

const getAwsKeyAndSecret = async (): Promise<Credentials> => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_AWS_ACCESS_FILEPATH}`);

   
    const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;

    const { AccessKeyId, SecretAccessKey } = data;

    if (!AccessKeyId || !SecretAccessKey) {
      throw new Error("Missing AccessKeyId or SecretAccessKey in S3 file.");
    }

    return {
      accessKeyId: AccessKeyId,
      secretAccessKey: SecretAccessKey,
    };

  } catch (err) {
    console.error(" Error fetching credentials from S3:", err);
    throw new Error("Failed to fetch AWS credentials from S3.");
  }
};

export const dynamodb = new DynamoDBClient({
  region: "ap-south-1",
  credentials: async () => await getAwsKeyAndSecret(),
});

interface StockConfig {
  Stock_Ticker_Symbol: string;
  [key: string]: any; // For any additional attributes
}

// Interface for the function response
interface GetStockConfigsResponse {
  success: boolean;
  data?: StockConfig[];
  count?: number;
  error?: string;
}

export const getTickers = async () => {
  // Query all the items from the DynamoDB table
  const params: ScanCommandInput = {
    TableName: "ConfigTable",
  };

  try {
    const items: StockConfig[] = [];
    let lastEvaluatedKey: Record<string, any> | undefined = undefined;

    // Handle pagination since scan has a limit of 1MB per request
    do {
      if (lastEvaluatedKey) {
        params.ExclusiveStartKey = lastEvaluatedKey;
      }

      const command = new ScanCommand(params);
      const response: ScanCommandOutput = await dynamodb.send(command);

      // Convert DynamoDB records to regular JavaScript objects
      const unmarshalledItems = response.Items?.map(item =>
          unmarshall(item) as StockConfig
      ) || [];

      items.push(...unmarshalledItems);

      lastEvaluatedKey = response.LastEvaluatedKey;
    } while (lastEvaluatedKey);

    // console.log("Items:", items);
    return {
      success: true,
      data: items,
      count: items.length,
    };
  } catch (error) {
    console.error("Error scanning DynamoDB table:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error occurred",
    };
  }
};
